<template>
  <div>
    <div class="footer" ref="foot" :class="isFixed ? 'fixed' : ''">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">品类齐全 轻松购物</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">多仓直发 极速配送</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">正品行货 精致服务</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">天天低价 畅选无忧</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <div class="servece-type-info" v-for="(guide, index) in guideArr" :key="index">
            <ul>
              <li v-for="(item, index) in guide" :key="index" @click="goto(item)">{{item}}</li>
            </ul>
          </div>
          <div class="company_info">
            <div>
              <div class="logo">
                <img :src="imgLogo" alt="">
                <div class="name">工业品的中央厨房</div>
              </div>
              <div class="work_time">工作时间：周一到周五 8:00 - 17:00</div>
              <div class="phone_area">
                <img src="../../../static/img/footer/phone.png" alt="">
                <div class="phone">{{ titphone }}</div>
              </div>
            </div>
          </div>
          <!-- 小程序二维码 -->
<!--          v-if="codeid!='81' && codeid!='120'"         -->
          <div class="wx_programs" v-if="HomeBanner">
            <div class="programs_info">
              <div class="qr_area">
                <img :src="HomeBanner">
<!--                <img src="../../../static/img/footer/wx_qr.png" alt="">-->
              </div>
              <div>微信小程序</div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- <div class="friend-link">
          <div class="friend-link-item">
            <ul>
              <li v-for="(link, index) in moreLink" :key="index">
                <span :class="[linkItemClass, {'link-last-item': index === 9}]">{{link}}</span>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="clearfix"></div>
        <div class="copyright">
          <p>
            Copyright ©2021-2022 {{companyname}} All rights reserved
            <a href="https://beian.miit.gov.cn/" target="_blank"
              ><span class="center">{{icp}}</span></a
            >
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33042102000746"
              target="_blank"
              ><span>{{poltce}}</span></a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {searchWebConfigInfoByConfCodes, } from "../../api/companies";
import {getHomeBannerByType} from '@/api/user'
import store from "@/vuex/store";
export default {
  name: "Footer",
  data() {
    return {
      linkItemClass: "link-item",
      guideArr: [
        ["如何下单", "购物流程", "常见问题"],
        ["购物平台", "发票须知", "如何支付"],
        ["售后服务", "售后政策", "投诉与建议"],
        [
          "关于我们",
          "走进晋顺芯",
          // "招才纳贤",
          "联系方式"
          ]
      ],
      //电话
      titphone:"",
      icp:"",
      poltce:"",
      logoimg:"",
      companyname:"",
      codeid:"",
      wx_logo:null
      // moreLink: [
      //   "危险化学品经营许可证",
      //   "食品经营许可证",
      //   "非药品易制毒化学品经营备案证明",
      //   "医疗器械经营许可证",
      //   "互联网药品信息服务资格证书",
      //   "网站地图"
      // ]
    };
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    HomeBanner() {
      let banner = store.state.HomeBanner.find(item => item.type === 10);    
      return banner? banner.list[0].imageUrl:''
    },
    imgLogo() {
      let imgLogo = store.state.HomeBanner.find(item => item.type === 9);   
      return imgLogo?imgLogo.list[0].imageUrl:''
    },
  },
  methods : {
    bannersearchHomeBannerInfo(){
      // getHomeBannerByType(10).then(res => {
      //   if (res.data.code === 200) {
      //     let carouselItems = res.data.data;
      //     if (carouselItems){
      //       this.wx_logo=carouselItems[0].imageUrl
      //     }else {
      //       this.wx_logo=null
      //     }
      //   }
      // });
    },
    searchWebConfigInfoByConfCodes(){
      let pramas=["SERVICE_HOTLINE","ICP_NO","POLICE_NO","CORP_NAME"]
      searchWebConfigInfoByConfCodes(pramas).then(res=>{
        if(res.data.code===200){
          this.titphone=res.data.data.find(i=>i.confCode==="SERVICE_HOTLINE").confValue
          this.icp=res.data.data.find(i=>i.confCode==="ICP_NO").confValue
          this.poltce=res.data.data.find(i=>i.confCode==="POLICE_NO").confValue
          this.companyname=res.data.data.find(i=>i.confCode==="CORP_NAME").confValue
          store.commit("SET_PHONE", this.titphone);
        }
      })
    },

    goto(item) {
      if(item === "购物流程") {
        this.$router.push('/shoppingFlow')
      }
      if(item === "常见问题") {
        this.$router.push('normalQuestion')
      }
      if(item === "发票须知") {
        this.$router.push('/billKnow')
      }
      if(item === "如何支付") {
        this.$router.push('howPay')
      }
      if(item === "售后政策") {
        this.$router.push('servicePolicy')
      }
      if(item === "投诉与建议") {
        this.$router.push('requestSuggest')
      }
      if(item === "走进晋顺芯") {
        this.$router.push('goCompany')
      }
      // if(item === "招才纳贤") {
      //   this.$router.push('advertise')
      // }
      if(item === "联系方式") {
        this.$router.push('/contact')
      }
    }
  },
  mounted() {
    // webConfigsearchWebConfigInfoByConfCode({
    //   confCode:"SERVICE_HOTLINE"
    // }).then(res=>{
    //   this.titphone=res.data.data[0].  
    // })
    // webConfigsearchWebConfigInfoByConfCode({
    //   confCode:"ICP_NO"
    // }).then(res=>{
    //   this.icp=res.data.data[0].confValue
    // })
    // webConfigsearchWebConfigInfoByConfCode({
    //   confCode:"POLICE_NO"
    // }).then(res=>{
    //   this.poltce=res.data.data[0].confValue
    // })
    // webConfigsearchWebConfigInfoByConfCode({
    //   confCode:"CORP_NAME"
    // }).then(res=>{
    //   this.companyname=res.data.data[0].confValue
    // })
    this.searchWebConfigInfoByConfCodes()
    // getHomeBannerByType(9).then(res=>{
    //   if (res.data.code === 200) {
    //     let carouselItems = res.data.data;
    //     this.logoimg=carouselItems[0].imageUrl
    //   }
    // })
    this.bannersearchHomeBannerInfo()
    let host = document.domain;
    //根据域名得到不同公司ID
    if(host == 'mall81.fat.gemsf.cn'){
      this.codeid=81;
    }else if(host == 'mall82.fat.gemsf.cn'){
      this.codeid=82;
    }else if(host == 'mall83.fat.gemsf.cn'){
      this.codeid=83;
    }else if(host == 'mall.fat.gemsf.cn'){
      this.codeid=84;
    }else{
      this.codeid=81;
    }

  }
};
</script>

<style lang="scss" scoped>
/*****************************底 部 开 始*****************************/
.footer {
  width: 100%;
  height: 190px;
  /*margin-top: 30px;*/
  // background-color: #ffffff;
  background: #F5F5F5;
}
.fixed {
  position: fixed;
  left: 0;
  bottom: 0;
}
.icon-row {
  margin: 0 auto;
  padding-top: 8px;
  width: 1152px;
  height: 140px;
  /* background-color: #ccc; */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.footer-icon {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}
.footer-icon-child {
  overflow: hidden;
  position: absolute;
  top: -12px;
  width: 50px;
  height: 58px;
  background-image: url("../../../static/img/footer/ico_service.png");
  text-indent: -999px;
  background-size: 100% auto;
}
.footer-icon-child-2 {
  background-position: 0 -58px;
}
.footer-icon-child-3 {
  background-position: 0 -116px;
}
.footer-icon-child-4 {
  background-position: 0 -174px;
}
.footer-icon-text {
  margin-left: 60px;
  font-size: 18px;
  line-height: 64px;
  font-weight: 400;
  color: #444444;
  letter-spacing: 5px;
}
.service-intro {
  width: 100%;
  // background: #34385e;
  background:  #EEEEEE;
  /* border-top: 1px solid #b2dfdb; */
}
.servece-type {
  margin: 15px auto;
  padding: 29px 0;
  width: 1152px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #CCCCCC;
}
.servece-type-info {
  color: #666666;
  border-right: 1px solid #D8D8D8;
}
.servece-type-info ul {
  width: 144px;
  text-align: center;
  list-style: none;
}
.servece-type-info li {
  font-size: 12px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
  cursor: default;
}
.company_info{
  display: flex;
  justify-content: center;
  width: 235px;
  border-right: 1px solid #D8D8D8;
  .work_time{
    margin-bottom: 12px;
    color: #666666;
  }
  .logo{
    margin: 0 auto;
    text-align: center;
    width: 135px;
    border-bottom: 1px solid #666666 ;
    margin-bottom: 10px;
    img{
      margin-bottom: 10px;
    }
    .name{
      margin-bottom: 10px;
      color: #333333;
    }
  }
  .phone_area{
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img{
      margin-right: 10px;

    }
    .phone{
      color: #FF6900;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
.wx_programs{
  padding-left: 40px;
  width: 144px;
  display: flex;
  justify-content: center;
  .programs_info{
    text-align: center;
    color: #333333;
    .qr_area{
      width: 129px;
      height: 129px;
      background: #D8D8D8;

      margin-bottom: 10px;
      img{
        // border-radius: 6px;
        width: 129px;
        height: 129px;
      }
    }
  }
}
.friend-link {
  display: flex;
  align-items: center;
  width: 908px;
  height: 30px;
  margin: 0px auto;
  color: #666;
  /* border-top: 1px solid #b2dfdb; */
}
.friend-link-item {
  margin: 0px auto;
}
.friend-link-item ul {
  list-style: none;
}
.friend-link-item li {
  padding: 5px 0px;
  float: left;
}
.link-item {
  padding: 0px 8px;
  cursor: pointer;
  border-right: 1px solid #ccc;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  line-height: 50px;
  text-align: center;
  p {
    margin: 0;
    a {
      font-size: 12px;
      font-weight: 400;
      // color: #cccccc;
      color: #333;
    }
    span {
      cursor: pointer;
    }
    .center {
      padding: 0 15px;
      border-left: 1px solid #333;
      border-right: 1px solid #333;
      margin: 0 15px;
      color: #333;
    }
  }
}
.copyright a {
  color: #232323;
  font-size: 20px;
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue